import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ACADEMY } from "@/lib/constants";

export const monthLabel = (ym, lang) => new Date(`${ym}-15T12:00:00`).toLocaleDateString(lang === "es" ? "es-US" : "en-US", { month: "short", year: "numeric" });

// Milestone text lives in ACADEMY; status and month come from Master Admin when set.
export function useAcademy(lang) {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/public/academy").then((r) => setO(r.data)).catch(() => {}); }, []);
  const milestones = ACADEMY.milestones.map((m, i) => {
    const x = o?.milestones?.[i];
    return { ...m, status: x?.status || m.status, when: x?.date ? monthLabel(x.date, lang) : m.date?.[lang] || "" };
  });
  const updated = o?.updated_at ? new Date(o.updated_at).toLocaleDateString(lang === "es" ? "es-US" : "en-US", { month: "long", year: "numeric" }) : ACADEMY.updated[lang];
  return { milestones, updated };
}
